/**
 * Design board user-facing labels.
 * Use these constants for all end-user visible text to ensure consistent terminology.
 */
export const BOARD_TERMS = {
    /** Singular: "Design Board" */
    singular: 'Design Board',
    /** Plural: "Design Boards" */
    plural: 'Design Boards',
    /** "My Design Boards" - used in nav and page titles */
    myBoards: 'My Design Boards',
    /** "All Design Boards" - filter label */
    allBoards: 'All Design Boards',
    /** "Start building your design boards" - empty state heading */
    emptyStateHeading: 'Start building your design boards',
    /** "Save to Design Board" - modal header, button label */
    saveTo: 'Save to Design Board',
    /** "Failed to load design boards" - error message */
    failedToLoad: 'Failed to load design boards',
    /** "Name your design board" - placeholder */
    nameYourBoard: 'Name your design board',
    /** "Saved to Design Board" - toast message */
    savedTo: 'Saved to Design Board',
    /** "View Design Board" - toast action label */
    viewBoard: 'View Design Board',
    /** "Removed from Design Board" - toast message */
    removedFrom: 'Removed from Design Board',
    /** "Share Design Board" - modal title */
    shareBoard: 'Share Design Board',
    /** "Manage who can access this design board and what they can do" - modal description */
    manageAccessDescription:
        'Manage who can access this design board and what they can do',
    /** "Add your first design board" - empty state heading */
    addFirstBoard: 'Add your first design board',
    /** "Create a Design Board" - button label */
    createBoard: 'Create a Design Board',
    /** "Invite people to collaborate on this design board" - form label */
    inviteCollaborators: 'Invite people to collaborate on this design board',
    /** "Select a design board" - aria-label */
    selectBoard: 'Select a design board',
    /** "Following design board" - toast message */
    followingBoard: 'Following design board',
    /** "Unfollowed design board" - toast message */
    unfollowedBoard: 'Unfollowed design board',
    /** "Add to design board" - button label (lowercase) */
    addToBoard: 'Add to design board',
    /** "design board" - lowercase for use in sentences (e.g. testimonials) */
    boardLowercase: 'design board',
    /** "Search Design Boards" - search placeholder */
    searchBoards: 'Search Design Boards',
    /** "Edit Design Board" - modal title */
    editBoard: 'Edit Design Board',
    /** "Design board updated" - toast message */
    updated: 'Design board updated',
    /** "Failed to update design board" - error message */
    failedToUpdate: 'Failed to update design board',
    /** "Failed to create design board" - error message */
    failedToCreate: 'Failed to create design board',
    /** "New Design Board" - modal title when creating */
    newBoard: 'New Design Board',
    /** "My First Design Board" - placeholder for new board title */
    firstBoardPlaceholder: 'My First Design Board',
    /** "My Design Board" - placeholder for board title */
    myBoardPlaceholder: 'My Design Board',
    /** "Go to Design Boards" - link label */
    goToBoards: 'Go to Design Boards',
    /** "Delete Design Board" - button label */
    deleteBoard: 'Delete Design Board',
} as const;
